import axios from "axios";
import Cache from "utils/http/cache";

const cache = new Cache();

const defaultAdapter = axios.defaults.adapter;

export default (cacheConfig) => (config) => {
    const routeConfig = cacheConfig(config);

    if(routeConfig) {
        let promise = cache.get(routeConfig.key);

        if(!promise) {
            promise = defaultAdapter(config);
            cache.set(routeConfig.key, promise, routeConfig.expiresIn);
        }

        return promise;
    } else {
        return defaultAdapter(config);
    }
};